import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import config from 'config';
import rootReducer from '../reducers';
import { trialReportCardMiddleware } from '../components/TrialReportCard/trialReportCard.middleware';

const composeEnhancers =
  config.extensions.useReduxDevExtension && typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunkMiddleware, trialReportCardMiddleware),
);

const store = createStore(rootReducer, enhancer);

export default store;
